import { EditorSide } from '@/shared/types/configurator';
import { create } from 'zustand';
import { ConfiguratorSideApi } from '../types/configurator-side.types';

export const useConfiguratorSide = create<ConfiguratorSideApi>((set) => ({
	side: EditorSide.FRONT,

	setSide: (side: EditorSide) => set({ side }),
}));
